/**
 * <Pic /> — drop-in <img> replacement.
 *
 * AVIF is OPT-IN: pass `avif` prop with the explicit AVIF URL when you know
 * the file exists. Without it we render a plain <img> so missing AVIFs cannot
 * silently break the image (browsers do NOT fall through from a 404'd
 * <picture><source> — contrary to a widespread assumption — and we were
 * shipping orphan <source> tags pointing at AVIFs that never existed on disk).
 *
 * Usage:
 *   <Pic src="/images/foo.webp" alt="..." />                  // plain img, safest
 *   <Pic src="/images/foo.webp" avif="/images/foo.avif" />    // explicit AVIF
 */
export const Pic = ({ src, alt = '', className, loading = 'lazy', width, height, avif, ...rest }) => {
  if (!avif) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        loading={loading}
        decoding="async"
        width={width}
        height={height}
        {...rest}
      />
    );
  }
  return (
    <picture>
      <source type="image/avif" srcSet={avif} />
      <img
        src={src}
        alt={alt}
        className={className}
        loading={loading}
        decoding="async"
        width={width}
        height={height}
        {...rest}
      />
    </picture>
  );
};

export default Pic;
